<template>
    <div class="table-responsive">
        <table class="table-bordered table">
            <colgroup>
                <template v-for="(col, i) in CONFIG_TABLE_TAB_10().headers">
                    <col v-for="n in col.colspan || 1" :key="i + '-' + n" :style="{ width: col.width }" />
                </template>
            </colgroup>
            <tbody>
                <tr>
                    <th :colspan="lengthHeaders">＜抽選条件＞※応募割れの場合は抽選条件が変わる可能性があります。</th>
                </tr>
                <template v-if="SWITCH_FIELD_TAB_10(dataObject.hashtags, isPreview)['賞品']">
                    <tr>
                        <template v-for="(objHeader, idx) in CONFIG_TABLE_TAB_10().headers">
                            <th
                                v-if="idx == 0"
                                :key="idx"
                                :rowspan="dataObject.hashtags.data.length + 1"
                                :class="objHeader.bgClass"
                                style="padding-left: 3px"
                            >
                                <div class="d-flex flex-wrap align-items-center">
                                    <b-form-checkbox
                                        v-if="!isPreview && !isRolePartner"
                                        switch
                                        v-model="SWITCH_FIELD_TAB_10(dataObject.hashtags)['賞品']"
                                        @change="toggleCommonSwitch($event, dataObject.hashtags.data)"
                                    />
                                    <div>{{ objHeader.label }}</div>
                                </div>
                            </th>
                            <th v-else :key="idx" :class="objHeader.bgClass" :colspan="objHeader.colspan">{{ objHeader.label }}</th>
                        </template>
                    </tr>
                    <tr v-for="(item, k) in dataObject.hashtags.data" :key="item.name">
                        <td class="bg-color4">{{ item.name }}</td>
                        <td>
                            <InputText
                                :model.sync="dataObject.hashtags.data[k].number_of_win"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_10(dataObject.hashtags)['賞品']"
                                :config="inputConfig.num"
                                @change="
                                    (val) => {
                                        if (!val?.length) dataObject.hashtags.data[k].number_of_win = '0';
                                    }
                                "
                            />
                        </td>
                        <td>
                            <InputText
                                :model.sync="dataObject.hashtags.data[k].preliminary_winner"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_10(dataObject.hashtags)['賞品']"
                                :config="inputConfig.num"
                                @change="
                                    (val) => {
                                        if (!val?.length) dataObject.hashtags.data[k].preliminary_winner = '0';
                                    }
                                "
                            />
                        </td>
                        <td>
                            <TextareaComponent
                                :id="'tab10-textarea-hashtags-' + k"
                                :model.sync="item.write_freely"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_10(dataObject.hashtags)['賞品']"
                                :config="inputConfig.write_freely"
                                :isPreview="isPreview"
                            />
                        </td>
                        <td>
                            <div
                                :class="`d-flex align-items-center justify-content-center box--text__disabled ${isNotCheckBoxPartner || isDisabled || !SWITCH_FIELD_TAB_10(dataObject.hashtags)['賞品'] ? 'disabled_input' : ''}`"
                                :style="{
                                    'background-color':
                                        isNotCheckBoxPartner || isDisabled || !SWITCH_FIELD_TAB_10(dataObject.hashtags)['賞品'] ? '' : '#ffffff'
                                }"
                            >
                                {{ item.total_winner }}
                            </div>
                        </td>
                        <td v-if="k == 0" :rowspan="dataObject.hashtags.data.length" align="middle" style="vertical-align: middle">
                            <div
                                :class="`d-flex align-items-center justify-content-center box--text__disabled ${isNotCheckBoxPartner || isDisabled || !SWITCH_FIELD_TAB_10(dataObject.hashtags)['賞品'] ? 'disabled_input' : ''}`"
                                :style="{
                                    'background-color':
                                        isNotCheckBoxPartner || isDisabled || !SWITCH_FIELD_TAB_10(dataObject.hashtags)['賞品'] ? '' : '#ffffff'
                                }"
                            >
                                {{ dataObject.hashtags.sum_total_winner }}
                            </div>
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields[`hashtags_${k}_first`])"
                                v-model="item.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('hashtags', 'first', k)"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields[`hashtags_${k}_secondary`])"
                                v-model="item.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('hashtags', 'secondary', k)"
                            />
                        </td>
                    </tr>
                </template>
                <tr v-if="SWITCH_FIELD_TAB_10(dataObject, isPreview)['抽選方法']">
                    <td colspan="2" class="bg-color4">
                        <div class="d-flex flex-wrap align-items-center">
                            <b-form-checkbox
                                v-if="!isPreview && !isRolePartner"
                                switch
                                v-model="SWITCH_FIELD_TAB_10(dataObject)['抽選方法']"
                                @change="
                                    toggleCommonSwitch($event, {
                                        lottery_method: dataObject.lottery_method
                                    })
                                "
                            />
                            抽選方法
                        </div>
                    </td>
                    <td colspan="5">
                        <div
                            :class="`box--text__disabled ${isNotCheckBoxPartner || isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['抽選方法'] ? 'disabled_input' : ''}`"
                            :style="{
                                'background-color':
                                    isNotCheckBoxPartner || isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['抽選方法'] ? '' : '#ffffff',
                                'min-height': '37px'
                            }"
                        >
                            {{ dataObject.lottery_method.data }}
                        </div>
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.lottery_method_first)"
                            v-model="dataObject.lottery_method.first_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('lottery_method', 'first')"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.lottery_method_secondary)"
                            v-model="dataObject.lottery_method.secondary_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('lottery_method', 'secondary')"
                        />
                    </td>
                </tr>
                <tr v-if="SWITCH_FIELD_TAB_10(dataObject, isPreview)['対象ファイル']">
                    <td colspan="2" class="bg-color4">
                        <div class="d-flex flex-wrap align-items-center">
                            <b-form-checkbox
                                v-if="!isPreview && !isRolePartner"
                                switch
                                v-model="SWITCH_FIELD_TAB_10(dataObject)['対象ファイル']"
                                @change="
                                    toggleCommonSwitch($event, {
                                        target_file: dataObject.target_file
                                    })
                                "
                            />
                            対象ファイル
                        </div>
                    </td>
                    <td colspan="5">
                        <CommonMultiselect
                            v-model="dataObject.target_file.data"
                            :options.sync="option.target_file"
                            :disabled="isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['対象ファイル']"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.target_file_first)"
                            v-model="dataObject.target_file.first_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('target_file', 'first')"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.target_file_secondary)"
                            v-model="dataObject.target_file.secondary_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('target_file', 'secondary')"
                        />
                    </td>
                </tr>
                <tr v-if="SWITCH_FIELD_TAB_10(dataObject, isPreview)['期間条件（抽選対象期間）']">
                    <td colspan="2" class="bg-color4">
                        <div class="d-flex flex-wrap align-items-center">
                            <b-form-checkbox
                                v-if="!isPreview && !isRolePartner"
                                switch
                                v-model="SWITCH_FIELD_TAB_10(dataObject)['期間条件（抽選対象期間）']"
                                @change="
                                    toggleCommonSwitch($event, {
                                        period_conditions: dataObject.period_conditions
                                    })
                                "
                            />
                            期間条件（抽選対象期間）
                        </div>
                    </td>
                    <td colspan="5">
                        <div
                            :class="`box--text__disabled ${isNotCheckBoxPartner || isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['期間条件（抽選対象期間）'] ? 'disabled_input' : ''}`"
                            :style="{
                                'background-color':
                                    isNotCheckBoxPartner || isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['期間条件（抽選対象期間）']
                                        ? ''
                                        : '#ffffff',
                                'min-height': '37px'
                            }"
                        >
                            {{ formatDateTimeJapanese(detailBeginForDocument.campaign_start_date) }}～{{
                                formatDateTimeJapanese(detailBeginForDocument.campaign_end_date)
                            }}
                        </div>
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.period_conditions_first)"
                            v-model="dataObject.period_conditions.first_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('period_conditions', 'first')"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.period_conditions_secondary)"
                            v-model="dataObject.period_conditions.secondary_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('period_conditions', 'secondary')"
                        />
                    </td>
                </tr>

                <tr v-if="SWITCH_FIELD_TAB_10(dataObject, isPreview)['除外アカウント']">
                    <td colspan="2" class="bg-color4">
                        <div class="d-flex flex-wrap align-items-center">
                            <b-form-checkbox
                                v-if="!isPreview && !isRolePartner"
                                switch
                                v-model="SWITCH_FIELD_TAB_10(dataObject)['除外アカウント']"
                                @change="
                                    toggleCommonSwitch($event, {
                                        excluded_accounts: dataObject.excluded_accounts
                                    })
                                "
                            />
                            除外アカウント
                        </div>
                    </td>
                    <td colspan="5">
                        <TextareaComponent
                            id="tab10-textarea-1"
                            :model.sync="dataObject.excluded_accounts.data"
                            :disabled="isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['除外アカウント']"
                            :config="inputConfig.excluded_accounts"
                            :isPreview="isPreview"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.excluded_accounts_first)"
                            v-model="dataObject.excluded_accounts.first_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('excluded_accounts', 'first')"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.excluded_accounts_secondary)"
                            v-model="dataObject.excluded_accounts.secondary_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('excluded_accounts', 'secondary')"
                        />
                    </td>
                </tr>
                <template v-if="SWITCH_FIELD_TAB_10(dataObject, isPreview)['アカウント・投稿情報']">
                    <tr>
                        <td
                            :rowspan="calculateRowspan(SWITCH_FIELD_TAB_10(dataObject, isPreview), CONFIG_ROWSPAN_TAB_10['アカウント・投稿情報'])"
                            class="bg-color4"
                        >
                            <div class="d-flex flex-wrap align-items-center">
                                <b-form-checkbox
                                    v-if="!isPreview && !isRolePartner"
                                    switch
                                    v-model="SWITCH_FIELD_TAB_10(dataObject)['アカウント・投稿情報']"
                                    @change="
                                        toggleCommonSwitch($event, {
                                            official_account_follow_check_1: dataObject.official_account_follow_check_1,
                                            official_account_follow_check_2: dataObject.official_account_follow_check_2,
                                            number_of_followers: dataObject.number_of_followers,
                                            number_of_follower_detail: dataObject.number_of_follower_detail,
                                            number_of_posts: dataObject.number_of_posts,
                                            number_of_post_detail: dataObject.number_of_post_detail,
                                            number_of_likes: dataObject.number_of_likes,
                                            number_of_like_detail: dataObject.number_of_like_detail,
                                            required_words_in_the_post: dataObject.required_words_in_the_post,
                                            post_word_count: dataObject.post_word_count
                                        })
                                    "
                                />
                                アカウント・投稿情報
                            </div>
                        </td>
                        <template v-if="SWITCH_FIELD_TAB_10(dataObject, isPreview)['公式アカウントフォローチェック']">
                            <td rowspan="2" class="bg-color4">
                                <div class="d-flex flex-wrap align-items-center">
                                    <b-form-checkbox
                                        v-if="!isPreview && !isRolePartner"
                                        switch
                                        v-model="SWITCH_FIELD_TAB_10(dataObject)['公式アカウントフォローチェック']"
                                        :disabled="!SWITCH_FIELD_TAB_10(dataObject)['アカウント・投稿情報']"
                                        @change="
                                            toggleCommonSwitch($event, {
                                                official_account_follow_check_1: dataObject.official_account_follow_check_1,
                                                official_account_follow_check_2: dataObject.official_account_follow_check_2
                                            })
                                        "
                                    />
                                    公式アカウントフォローチェック
                                </div>
                            </td>
                            <td colspan="5">
                                <TextareaComponent
                                    id="tab10-textarea-2"
                                    :model.sync="dataObject.official_account_follow_check_1.data"
                                    :disabled="isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['公式アカウントフォローチェック']"
                                    :config="inputConfig.official_account_follow_check_1"
                                    :isPreview="isPreview"
                                />
                            </td>
                            <td>
                                <CommonCheckbox
                                    :disabled="isNotCheckBoxPartner || (processingFields && processingFields.official_account_follow_check_1_first)"
                                    v-model="dataObject.official_account_follow_check_1.first_check"
                                    :currentUser="currentUser"
                                    @input="handleCheckBoxValue('official_account_follow_check_1', 'first')"
                                />
                            </td>
                            <td>
                                <CommonCheckbox
                                    :disabled="
                                        isNotCheckBoxPartner || (processingFields && processingFields.official_account_follow_check_1_secondary)
                                    "
                                    v-model="dataObject.official_account_follow_check_1.secondary_check"
                                    :currentUser="currentUser"
                                    @input="handleCheckBoxValue('official_account_follow_check_1', 'secondary')"
                                />
                            </td>
                        </template>
                    </tr>
                    <tr v-if="SWITCH_FIELD_TAB_10(dataObject, isPreview)['公式アカウントフォローチェック']">
                        <td colspan="5">
                            <TextareaComponent
                                id="tab10-textarea-3"
                                :model.sync="dataObject.official_account_follow_check_2.data"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['公式アカウントフォローチェック']"
                                :config="inputConfig.official_account_follow_check_2"
                                :isPreview="isPreview"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.official_account_follow_check_2_first)"
                                v-model="dataObject.official_account_follow_check_2.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('official_account_follow_check_2', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.official_account_follow_check_2_secondary)"
                                v-model="dataObject.official_account_follow_check_2.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('official_account_follow_check_2', 'secondary')"
                            />
                        </td>
                    </tr>
                    <template v-if="SWITCH_FIELD_TAB_10(dataObject, isPreview)['フォロワー数']">
                        <tr>
                            <td rowspan="2" class="bg-color4">
                                <div class="d-flex flex-wrap align-items-center">
                                    <b-form-checkbox
                                        v-if="!isPreview && !isRolePartner"
                                        switch
                                        v-model="SWITCH_FIELD_TAB_10(dataObject)['フォロワー数']"
                                        :disabled="!SWITCH_FIELD_TAB_10(dataObject)['アカウント・投稿情報']"
                                        @change="
                                            toggleCommonSwitch($event, {
                                                number_of_followers: dataObject.number_of_followers,
                                                number_of_follower_detail: dataObject.number_of_follower_detail
                                            })
                                        "
                                    />
                                    フォロワー数
                                </div>
                            </td>
                            <td colspan="5">
                                <CommonMultiselect
                                    v-model="dataObject.number_of_followers.data"
                                    :options.sync="option.number_of_followers"
                                    :disabled="isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['フォロワー数']"
                                />
                            </td>
                            <td>
                                <CommonCheckbox
                                    :disabled="isNotCheckBoxPartner || (processingFields && processingFields.number_of_followers_first)"
                                    v-model="dataObject.number_of_followers.first_check"
                                    :currentUser="currentUser"
                                    @input="handleCheckBoxValue('number_of_followers', 'first')"
                                />
                            </td>
                            <td>
                                <CommonCheckbox
                                    :disabled="isNotCheckBoxPartner || (processingFields && processingFields.number_of_followers_secondary)"
                                    v-model="dataObject.number_of_followers.secondary_check"
                                    :currentUser="currentUser"
                                    @input="handleCheckBoxValue('number_of_followers', 'secondary')"
                                />
                            </td>
                        </tr>
                        <tr>
                            <td colspan="5">
                                <TextareaComponent
                                    id="tab10-textarea-4"
                                    :model.sync="dataObject.number_of_follower_detail.data"
                                    :disabled="isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['フォロワー数']"
                                    :config="inputConfig.number_of_follower_detail"
                                    :isPreview="isPreview"
                                />
                            </td>
                            <td>
                                <CommonCheckbox
                                    :disabled="isNotCheckBoxPartner || (processingFields && processingFields.number_of_follower_detail_first)"
                                    v-model="dataObject.number_of_follower_detail.first_check"
                                    :currentUser="currentUser"
                                    @input="handleCheckBoxValue('number_of_follower_detail', 'first')"
                                />
                            </td>
                            <td>
                                <CommonCheckbox
                                    :disabled="isNotCheckBoxPartner || (processingFields && processingFields.number_of_follower_detail_secondary)"
                                    v-model="dataObject.number_of_follower_detail.secondary_check"
                                    :currentUser="currentUser"
                                    @input="handleCheckBoxValue('number_of_follower_detail', 'secondary')"
                                />
                            </td>
                        </tr>
                    </template>
                    <template v-if="SWITCH_FIELD_TAB_10(dataObject, isPreview)['投稿数']">
                        <tr>
                            <td rowspan="2" class="bg-color4">
                                <div class="d-flex flex-wrap align-items-center">
                                    <b-form-checkbox
                                        v-if="!isPreview && !isRolePartner"
                                        switch
                                        v-model="SWITCH_FIELD_TAB_10(dataObject)['投稿数']"
                                        :disabled="!SWITCH_FIELD_TAB_10(dataObject)['アカウント・投稿情報']"
                                        @change="
                                            toggleCommonSwitch($event, {
                                                number_of_posts: dataObject.number_of_posts,
                                                number_of_post_detail: dataObject.number_of_post_detail
                                            })
                                        "
                                    />
                                    投稿数
                                </div>
                            </td>
                            <td colspan="5">
                                <CommonMultiselect
                                    v-model="dataObject.number_of_posts.data"
                                    :options.sync="option.number_of_posts"
                                    :disabled="isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['投稿数']"
                                />
                            </td>
                            <td>
                                <CommonCheckbox
                                    :disabled="isNotCheckBoxPartner || (processingFields && processingFields.number_of_posts_first)"
                                    v-model="dataObject.number_of_posts.first_check"
                                    :currentUser="currentUser"
                                    @input="handleCheckBoxValue('number_of_posts', 'first')"
                                />
                            </td>
                            <td>
                                <CommonCheckbox
                                    :disabled="isNotCheckBoxPartner || (processingFields && processingFields.number_of_posts_secondary)"
                                    v-model="dataObject.number_of_posts.secondary_check"
                                    :currentUser="currentUser"
                                    @input="handleCheckBoxValue('number_of_posts', 'secondary')"
                                />
                            </td>
                        </tr>
                        <tr>
                            <td colspan="5">
                                <TextareaComponent
                                    id="tab10-textarea-5"
                                    :model.sync="dataObject.number_of_post_detail.data"
                                    :disabled="isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['投稿数']"
                                    :config="inputConfig.number_of_post_detail"
                                    :isPreview="isPreview"
                                />
                            </td>
                            <td>
                                <CommonCheckbox
                                    :disabled="isNotCheckBoxPartner || (processingFields && processingFields.number_of_post_detail_first)"
                                    v-model="dataObject.number_of_post_detail.first_check"
                                    :currentUser="currentUser"
                                    @input="handleCheckBoxValue('number_of_post_detail', 'first')"
                                />
                            </td>
                            <td>
                                <CommonCheckbox
                                    :disabled="isNotCheckBoxPartner || (processingFields && processingFields.number_of_post_detail_secondary)"
                                    v-model="dataObject.number_of_post_detail.secondary_check"
                                    :currentUser="currentUser"
                                    @input="handleCheckBoxValue('number_of_post_detail', 'secondary')"
                                />
                            </td>
                        </tr>
                    </template>
                    <template v-if="SWITCH_FIELD_TAB_10(dataObject, isPreview)['いいね数']">
                        <tr>
                            <td rowspan="2" class="bg-color4">
                                <div class="d-flex flex-wrap align-items-center">
                                    <b-form-checkbox
                                        v-if="!isPreview && !isRolePartner"
                                        switch
                                        v-model="SWITCH_FIELD_TAB_10(dataObject)['いいね数']"
                                        :disabled="!SWITCH_FIELD_TAB_10(dataObject)['アカウント・投稿情報']"
                                        @change="
                                            toggleCommonSwitch($event, {
                                                number_of_likes: dataObject.number_of_likes,
                                                number_of_like_detail: dataObject.number_of_like_detail
                                            })
                                        "
                                    />
                                    いいね数
                                </div>
                            </td>
                            <td colspan="5">
                                <CommonMultiselect
                                    v-model="dataObject.number_of_likes.data"
                                    :options.sync="option.number_of_likes"
                                    :disabled="isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['いいね数']"
                                />
                            </td>
                            <td>
                                <CommonCheckbox
                                    :disabled="isNotCheckBoxPartner || (processingFields && processingFields.number_of_likes_first)"
                                    v-model="dataObject.number_of_likes.first_check"
                                    :currentUser="currentUser"
                                    @input="handleCheckBoxValue('number_of_likes', 'first')"
                                />
                            </td>
                            <td>
                                <CommonCheckbox
                                    :disabled="isNotCheckBoxPartner || (processingFields && processingFields.number_of_likes_secondary)"
                                    v-model="dataObject.number_of_likes.secondary_check"
                                    :currentUser="currentUser"
                                    @input="handleCheckBoxValue('number_of_likes', 'secondary')"
                                />
                            </td>
                        </tr>
                        <tr>
                            <td colspan="5">
                                <TextareaComponent
                                    id="tab10-textarea-6"
                                    :model.sync="dataObject.number_of_like_detail.data"
                                    :disabled="isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['いいね数']"
                                    :config="inputConfig.number_of_like_detail"
                                    :isPreview="isPreview"
                                />
                            </td>
                            <td>
                                <CommonCheckbox
                                    :disabled="isNotCheckBoxPartner || (processingFields && processingFields.number_of_like_detail_first)"
                                    v-model="dataObject.number_of_like_detail.first_check"
                                    :currentUser="currentUser"
                                    @input="handleCheckBoxValue('number_of_like_detail', 'first')"
                                />
                            </td>
                            <td>
                                <CommonCheckbox
                                    :disabled="isNotCheckBoxPartner || (processingFields && processingFields.number_of_like_detail_secondary)"
                                    v-model="dataObject.number_of_like_detail.secondary_check"
                                    :currentUser="currentUser"
                                    @input="handleCheckBoxValue('number_of_like_detail', 'secondary')"
                                />
                            </td>
                        </tr>
                    </template>
                    <tr v-if="SWITCH_FIELD_TAB_10(dataObject, isPreview)['投稿内必須ワード']">
                        <td class="bg-color4">
                            <div class="d-flex flex-wrap align-items-center">
                                <b-form-checkbox
                                    v-if="!isPreview && !isRolePartner"
                                    switch
                                    v-model="SWITCH_FIELD_TAB_10(dataObject)['投稿内必須ワード']"
                                    :disabled="!SWITCH_FIELD_TAB_10(dataObject)['アカウント・投稿情報']"
                                    @change="
                                        toggleCommonSwitch($event, {
                                            required_words_in_the_post: dataObject.required_words_in_the_post
                                        })
                                    "
                                />
                                投稿内必須ワード
                            </div>
                        </td>
                        <td colspan="5">
                            <TextareaComponent
                                id="tab10-textarea-7"
                                :model.sync="dataObject.required_words_in_the_post.data"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['投稿内必須ワード']"
                                :config="inputConfig.required_words_in_the_post"
                                :isPreview="isPreview"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.required_words_in_the_post_first)"
                                v-model="dataObject.required_words_in_the_post.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('required_words_in_the_post', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.required_words_in_the_post_secondary)"
                                v-model="dataObject.required_words_in_the_post.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('required_words_in_the_post', 'secondary')"
                            />
                        </td>
                    </tr>
                    <tr v-if="SWITCH_FIELD_TAB_10(dataObject, isPreview)['投稿文文字数']">
                        <td class="bg-color4">
                            <div class="d-flex flex-wrap align-items-center">
                                <b-form-checkbox
                                    v-if="!isPreview && !isRolePartner"
                                    switch
                                    v-model="SWITCH_FIELD_TAB_10(dataObject)['投稿文文字数']"
                                    :disabled="!SWITCH_FIELD_TAB_10(dataObject)['アカウント・投稿情報']"
                                    @change="
                                        toggleCommonSwitch($event, {
                                            post_word_count: dataObject.post_word_count
                                        })
                                    "
                                />
                                投稿文文字数
                            </div>
                        </td>
                        <td colspan="5">
                            <TextareaComponent
                                id="tab10-textarea-8"
                                :model.sync="dataObject.post_word_count.data"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['投稿文文字数']"
                                :config="inputConfig.post_word_count"
                                :isPreview="isPreview"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.post_word_count_first)"
                                v-model="dataObject.post_word_count.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('post_word_count', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.post_word_count_secondary)"
                                v-model="dataObject.post_word_count.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('post_word_count', 'secondary')"
                            />
                        </td>
                    </tr>
                </template>

                <tr v-if="SWITCH_FIELD_TAB_10(dataObject, isPreview)['その他条件']">
                    <td colspan="2" class="bg-color4">
                        <div class="d-flex flex-wrap align-items-center">
                            <b-form-checkbox
                                v-if="!isPreview && !isRolePartner"
                                switch
                                v-model="SWITCH_FIELD_TAB_10(dataObject)['その他条件']"
                                @change="
                                    toggleCommonSwitch($event, {
                                        other_conditions: dataObject.other_conditions
                                    })
                                "
                            />
                            その他条件
                        </div>
                    </td>
                    <td colspan="5">
                        <TextareaComponent
                            id="tab10-textarea-9"
                            :model.sync="dataObject.other_conditions.data"
                            :disabled="isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['その他条件']"
                            :config="inputConfig.other_conditions"
                            :isPreview="isPreview"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.other_conditions_first)"
                            v-model="dataObject.other_conditions.first_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('other_conditions', 'first')"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.other_conditions_secondary)"
                            v-model="dataObject.other_conditions.secondary_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('other_conditions', 'secondary')"
                        />
                    </td>
                </tr>
                <tr v-if="SWITCH_FIELD_TAB_10(dataObject, isPreview)['＜抽選条件＞その他先_10']">
                    <td class="bg-color4" colspan="2">
                        <b-form-checkbox
                            v-if="!isPreview && !isRolePartner"
                            class="mb-1"
                            switch
                            v-model="SWITCH_FIELD_TAB_10(dataObject)['＜抽選条件＞その他先_10']"
                            @change="toggleCommonSwitch($event, { free_block_lottery_condition: dataObject.free_block_lottery_condition })"
                        />
                        <b-form-input
                            v-model="dataObject.free_block_lottery_condition.title"
                            :disabled="isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['＜抽選条件＞その他先_10']"
                            :class="`${isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['＜抽選条件＞その他先_10'] ? 'disabled_cursor' : ''} w-100`"
                        ></b-form-input>
                    </td>
                    <td colspan="5">
                        <div
                            v-if="isNotCheckBoxPartner || isDisabled"
                            class="box--text__disabled"
                            v-html="dataObject.free_block_lottery_condition.data"
                        ></div>
                        <Editor
                            v-else
                            :id="`editor-＜抽選条件＞その他先_10-${idTab}`"
                            :model.sync="dataObject.free_block_lottery_condition.data"
                            :configInit="{
                                disabled: forceEnableEditors ? false : isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['＜抽選条件＞その他先_10'],
                                is_autoresize_on: true
                            }"
                        />
                    </td>
                </tr>

                <tr>
                    <th :colspan="lengthHeaders">＜画像検閲＞</th>
                </tr>
                <template v-if="SWITCH_FIELD_TAB_10(dataObject, isPreview)['指定条件']">
                    <tr>
                        <td colspan="2" rowspan="3" class="bg-color4">
                            <div class="d-flex flex-wrap align-items-center">
                                <b-form-checkbox
                                    v-if="!isPreview && !isRolePartner"
                                    switch
                                    v-model="SWITCH_FIELD_TAB_10(dataObject)['指定条件']"
                                    @change="
                                        toggleCommonSwitch($event, {
                                            specified_condition_1: dataObject.specified_condition_1,
                                            specified_condition_2: dataObject.specified_condition_2,
                                            specified_condition_3: dataObject.specified_condition_3
                                        })
                                    "
                                />
                                指定条件
                            </div>
                        </td>
                        <td colspan="5">
                            <TextareaComponent
                                id="tab10-textarea-10"
                                :model.sync="dataObject.specified_condition_1.data"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['指定条件']"
                                :config="inputConfig.specified_condition_1"
                                :isPreview="isPreview"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.specified_condition_1_first)"
                                v-model="dataObject.specified_condition_1.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('specified_condition_1', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.specified_condition_1_secondary)"
                                v-model="dataObject.specified_condition_1.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('specified_condition_1', 'secondary')"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td colspan="5">
                            <TextareaComponent
                                id="tab10-textarea-11"
                                :model.sync="dataObject.specified_condition_2.data"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['指定条件']"
                                :config="inputConfig.specified_condition_2"
                                :isPreview="isPreview"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.specified_condition_2_first)"
                                v-model="dataObject.specified_condition_2.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('specified_condition_2', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.specified_condition_2_secondary)"
                                v-model="dataObject.specified_condition_2.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('specified_condition_2', 'secondary')"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td colspan="5">
                            <TextareaComponent
                                id="tab10-textarea-12"
                                :model.sync="dataObject.specified_condition_3.data"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['指定条件']"
                                :config="inputConfig.specified_condition_3"
                                :isPreview="isPreview"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.specified_condition_3_first)"
                                v-model="dataObject.specified_condition_3.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('specified_condition_3', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.specified_condition_3_secondary)"
                                v-model="dataObject.specified_condition_3.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('specified_condition_3', 'secondary')"
                            />
                        </td>
                    </tr>
                </template>

                <template v-if="SWITCH_FIELD_TAB_10(dataObject, isPreview)['確認件数']">
                    <tr>
                        <td colspan="2" rowspan="2" class="bg-color4">
                            <div class="d-flex flex-wrap align-items-center">
                                <b-form-checkbox
                                    v-if="!isPreview && !isRolePartner"
                                    switch
                                    v-model="SWITCH_FIELD_TAB_10(dataObject)['確認件数']"
                                    @change="
                                        toggleCommonSwitch($event, {
                                            number_of_confirmed_cases_1: dataObject.number_of_confirmed_cases_1,
                                            number_of_confirmed_cases_2: dataObject.number_of_confirmed_cases_2
                                        })
                                    "
                                />
                                確認件数
                            </div>
                        </td>
                        <td colspan="5">
                            <TextareaComponent
                                id="tab10-textarea-13"
                                :model.sync="dataObject.number_of_confirmed_cases_1.data"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['確認件数']"
                                :config="inputConfig.number_of_confirmed_cases_1"
                                :isPreview="isPreview"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.number_of_confirmed_cases_1_first)"
                                v-model="dataObject.number_of_confirmed_cases_1.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('number_of_confirmed_cases_1', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.number_of_confirmed_cases_1_secondary)"
                                v-model="dataObject.number_of_confirmed_cases_1.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('number_of_confirmed_cases_1', 'secondary')"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td colspan="5">
                            <TextareaComponent
                                id="tab10-textarea-14"
                                :model.sync="dataObject.number_of_confirmed_cases_2.data"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['確認件数']"
                                :config="inputConfig.number_of_confirmed_cases_2"
                                :isPreview="isPreview"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.number_of_confirmed_cases_2_first)"
                                v-model="dataObject.number_of_confirmed_cases_2.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('number_of_confirmed_cases_2', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.number_of_confirmed_cases_2_secondary)"
                                v-model="dataObject.number_of_confirmed_cases_2.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('number_of_confirmed_cases_2', 'secondary')"
                            />
                        </td>
                    </tr>
                </template>
                <tr v-if="SWITCH_FIELD_TAB_10(dataObject, isPreview)['＜画像検閲＞その他条件（別資料）']">
                    <td colspan="2" class="bg-color4">
                        <div class="d-flex flex-wrap align-items-center">
                            <b-form-checkbox
                                v-if="!isPreview && !isRolePartner"
                                switch
                                v-model="SWITCH_FIELD_TAB_10(dataObject)['＜画像検閲＞その他条件（別資料）']"
                                @change="
                                    toggleCommonSwitch($event, {
                                        others_conditions: dataObject.others_conditions
                                    })
                                "
                            />
                            その他条件（別資料）
                        </div>
                    </td>
                    <td colspan="5">
                        <TextareaComponent
                            id="tab10-textarea-15"
                            :model.sync="dataObject.others_conditions.data"
                            :disabled="isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['＜画像検閲＞その他条件（別資料）']"
                            :config="inputConfig.others_conditions"
                            :isPreview="isPreview"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.others_conditions_first)"
                            v-model="dataObject.others_conditions.first_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('others_conditions', 'first')"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.others_conditions_secondary)"
                            v-model="dataObject.others_conditions.secondary_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('others_conditions', 'secondary')"
                        />
                    </td>
                </tr>
                <tr v-if="SWITCH_FIELD_TAB_10(dataObject, isPreview)['＜画像検閲＞その他先_10']">
                    <td class="bg-color4" colspan="2">
                        <b-form-checkbox
                            v-if="!isPreview && !isRolePartner"
                            class="mb-1"
                            switch
                            v-model="SWITCH_FIELD_TAB_10(dataObject)['＜画像検閲＞その他先_10']"
                            @change="toggleCommonSwitch($event, { free_block_image_censorship: dataObject.free_block_image_censorship })"
                        />
                        <b-form-input
                            v-model="dataObject.free_block_image_censorship.title"
                            :disabled="isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['＜画像検閲＞その他先_10']"
                            :class="`${isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['＜画像検閲＞その他先_10'] ? 'disabled_cursor' : ''} w-100`"
                        ></b-form-input>
                    </td>
                    <td colspan="5">
                        <div
                            v-if="isNotCheckBoxPartner || isDisabled"
                            class="box--text__disabled"
                            v-html="dataObject.free_block_image_censorship.data"
                        ></div>
                        <Editor
                            v-else
                            :id="`editor-＜画像検閲＞その他先_10-${idTab}`"
                            :model.sync="dataObject.free_block_image_censorship.data"
                            :configInit="{
                                disabled: forceEnableEditors ? false : isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['＜画像検閲＞その他先_10'],
                                is_autoresize_on: true
                            }"
                        />
                    </td>
                </tr>

                <tr>
                    <th :colspan="lengthHeaders">＜重複・懸賞チェック＞</th>
                </tr>
                <tr v-if="SWITCH_FIELD_TAB_10(dataObject, isPreview)['＜重複・懸賞チェック＞重複条件']">
                    <td class="bg-color4">
                        <div class="d-flex flex-wrap align-items-center">
                            <b-form-checkbox
                                v-if="!isPreview && !isRolePartner"
                                switch
                                v-model="SWITCH_FIELD_TAB_10(dataObject)['＜重複・懸賞チェック＞重複条件']"
                                @change="
                                    toggleCommonSwitch($event, {
                                        overlapping_conditions_account_id: dataObject.overlapping_conditions_account_id
                                    })
                                "
                            />
                            重複条件
                        </div>
                    </td>
                    <td class="bg-color4">アカウントID</td>
                    <td colspan="5">
                        <TextareaComponent
                            id="tab10-textarea-16"
                            :model.sync="dataObject.overlapping_conditions_account_id.data"
                            :disabled="isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['＜重複・懸賞チェック＞重複条件']"
                            :config="inputConfig.overlapping_conditions_account_id"
                            :isPreview="isPreview"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.overlapping_conditions_account_id_first)"
                            v-model="dataObject.overlapping_conditions_account_id.first_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('overlapping_conditions_account_id', 'first')"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.overlapping_conditions_account_id_secondary)"
                            v-model="dataObject.overlapping_conditions_account_id.secondary_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('overlapping_conditions_account_id', 'secondary')"
                        />
                    </td>
                </tr>
                <tr v-if="SWITCH_FIELD_TAB_10(dataObject, isPreview)['その他確認項目']">
                    <td colspan="2" class="bg-color4">
                        <div class="d-flex flex-wrap align-items-center">
                            <b-form-checkbox
                                v-if="!isPreview && !isRolePartner"
                                switch
                                v-model="SWITCH_FIELD_TAB_10(dataObject)['その他確認項目']"
                                @change="
                                    toggleCommonSwitch($event, {
                                        other_items_to_check: dataObject.other_items_to_check
                                    })
                                "
                            />
                            その他確認項目
                        </div>
                    </td>
                    <td colspan="5">
                        <TextareaComponent
                            id="tab10-textarea-17"
                            :model.sync="dataObject.other_items_to_check.data"
                            :disabled="isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['その他確認項目']"
                            :config="inputConfig.other_items_to_check"
                            :isPreview="isPreview"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.other_items_to_check_first)"
                            v-model="dataObject.other_items_to_check.first_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('other_items_to_check', 'first')"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.other_items_to_check_secondary)"
                            v-model="dataObject.other_items_to_check.secondary_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('other_items_to_check', 'secondary')"
                        />
                    </td>
                </tr>
                <template v-if="SWITCH_FIELD_TAB_10(dataObject, isPreview)['懸賞確認']">
                    <tr>
                        <td
                            :rowspan="calculateRowspan(SWITCH_FIELD_TAB_10(dataObject, isPreview), CONFIG_ROWSPAN_TAB_10['懸賞確認'])"
                            class="bg-color4"
                        >
                            <div class="d-flex flex-wrap align-items-center">
                                <b-form-checkbox
                                    v-if="!isPreview && !isRolePartner"
                                    switch
                                    v-model="SWITCH_FIELD_TAB_10(dataObject)['懸賞確認']"
                                    @change="
                                        toggleCommonSwitch($event, {
                                            account_name: dataObject.account_name,
                                            specified_keywords: dataObject.specified_keywords,
                                            profile_statement: dataObject.profile_statement,
                                            presence_of_specified_keyword: dataObject.presence_of_specified_keyword,
                                            check_the_latest_posts_1: dataObject.check_the_latest_posts_1,
                                            check_the_latest_posts_2: dataObject.check_the_latest_posts_2,
                                            check_the_latest_posts_3: dataObject.check_the_latest_posts_3
                                        })
                                    "
                                />
                                懸賞確認
                            </div>
                        </td>
                        <template v-if="SWITCH_FIELD_TAB_10(dataObject, isPreview)['アカウント名\n指定キーワード有無']">
                            <td rowspan="2" class="bg-color4">
                                <div class="d-flex flex-wrap align-items-center">
                                    <b-form-checkbox
                                        v-if="!isPreview && !isRolePartner"
                                        switch
                                        v-model="SWITCH_FIELD_TAB_10(dataObject)['アカウント名\n指定キーワード有無']"
                                        :disabled="!SWITCH_FIELD_TAB_10(dataObject)['懸賞確認']"
                                        @change="
                                            toggleCommonSwitch($event, {
                                                account_name: dataObject.account_name,
                                                specified_keywords: dataObject.specified_keywords
                                            })
                                        "
                                    />
                                    アカウント名<br />
                                    指定キーワード有無
                                </div>
                            </td>
                            <td colspan="5">
                                <CommonMultiselect
                                    v-model="dataObject.account_name.data"
                                    :options.sync="option.account_name"
                                    :disabled="isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['アカウント名\n指定キーワード有無']"
                                />
                            </td>
                            <td>
                                <CommonCheckbox
                                    :disabled="isNotCheckBoxPartner || (processingFields && processingFields.account_name_first)"
                                    v-model="dataObject.account_name.first_check"
                                    :currentUser="currentUser"
                                    @input="handleCheckBoxValue('account_name', 'first')"
                                />
                            </td>
                            <td>
                                <CommonCheckbox
                                    :disabled="isNotCheckBoxPartner || (processingFields && processingFields.account_name_secondary)"
                                    v-model="dataObject.account_name.secondary_check"
                                    :currentUser="currentUser"
                                    @input="handleCheckBoxValue('account_name', 'secondary')"
                                />
                            </td>
                        </template>
                    </tr>
                    <tr v-if="SWITCH_FIELD_TAB_10(dataObject, isPreview)['アカウント名\n指定キーワード有無']">
                        <td colspan="5">
                            <TextareaComponent
                                id="tab10-textarea-18"
                                :model.sync="dataObject.specified_keywords.data"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['アカウント名\n指定キーワード有無']"
                                :config="inputConfig.specified_keywords"
                                :isPreview="isPreview"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.specified_keywords_first)"
                                v-model="dataObject.specified_keywords.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('specified_keywords', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.specified_keywords_secondary)"
                                v-model="dataObject.specified_keywords.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('specified_keywords', 'secondary')"
                            />
                        </td>
                    </tr>

                    <tr v-if="SWITCH_FIELD_TAB_10(dataObject, isPreview)['プロフィール文言\n指定キーワード有無']">
                        <td rowspan="2" class="bg-color4">
                            <div class="d-flex flex-wrap align-items-center">
                                <b-form-checkbox
                                    v-if="!isPreview && !isRolePartner"
                                    switch
                                    v-model="SWITCH_FIELD_TAB_10(dataObject)['プロフィール文言\n指定キーワード有無']"
                                    :disabled="!SWITCH_FIELD_TAB_10(dataObject)['懸賞確認']"
                                    @change="
                                        toggleCommonSwitch($event, {
                                            profile_statement: dataObject.profile_statement,
                                            presence_of_specified_keyword: dataObject.presence_of_specified_keyword
                                        })
                                    "
                                />
                                プロフィール文言<br />
                                指定キーワード有無
                            </div>
                        </td>
                        <td colspan="5">
                            <CommonMultiselect
                                v-model="dataObject.profile_statement.data"
                                :options.sync="option.profile_statement"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['プロフィール文言\n指定キーワード有無']"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.profile_statement_first)"
                                v-model="dataObject.profile_statement.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('profile_statement', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.profile_statement_secondary)"
                                v-model="dataObject.profile_statement.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('profile_statement', 'secondary')"
                            />
                        </td>
                    </tr>
                    <tr v-if="SWITCH_FIELD_TAB_10(dataObject, isPreview)['プロフィール文言\n指定キーワード有無']">
                        <td colspan="5">
                            <TextareaComponent
                                id="tab10-textarea-19"
                                :model.sync="dataObject.presence_of_specified_keyword.data"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['プロフィール文言\n指定キーワード有無']"
                                :config="inputConfig.presence_of_specified_keyword"
                                :isPreview="isPreview"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.presence_of_specified_keyword_first)"
                                v-model="dataObject.presence_of_specified_keyword.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('presence_of_specified_keyword', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.presence_of_specified_keyword_secondary)"
                                v-model="dataObject.presence_of_specified_keyword.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('presence_of_specified_keyword', 'secondary')"
                            />
                        </td>
                    </tr>

                    <tr v-if="SWITCH_FIELD_TAB_10(dataObject, isPreview)['直近投稿内容確認']">
                        <td rowspan="3" class="bg-color4">
                            <div class="d-flex flex-wrap align-items-center">
                                <b-form-checkbox
                                    v-if="!isPreview && !isRolePartner"
                                    switch
                                    v-model="SWITCH_FIELD_TAB_10(dataObject)['直近投稿内容確認']"
                                    :disabled="!SWITCH_FIELD_TAB_10(dataObject)['懸賞確認']"
                                    @change="
                                        toggleCommonSwitch($event, {
                                            check_the_latest_posts_1: dataObject.check_the_latest_posts_1,
                                            check_the_latest_posts_2: dataObject.check_the_latest_posts_2,
                                            check_the_latest_posts_3: dataObject.check_the_latest_posts_3
                                        })
                                    "
                                />
                                直近投稿内容確認
                            </div>
                        </td>
                        <td colspan="5">
                            <TextareaComponent
                                id="tab10-textarea-20"
                                :model.sync="dataObject.check_the_latest_posts_1.data"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['直近投稿内容確認']"
                                :config="inputConfig.check_the_latest_posts_1"
                                :isPreview="isPreview"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.check_the_latest_posts_1_first)"
                                v-model="dataObject.check_the_latest_posts_1.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('check_the_latest_posts_1', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.check_the_latest_posts_1_secondary)"
                                v-model="dataObject.check_the_latest_posts_1.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('check_the_latest_posts_1', 'secondary')"
                            />
                        </td>
                    </tr>
                    <tr v-if="SWITCH_FIELD_TAB_10(dataObject, isPreview)['直近投稿内容確認']">
                        <td colspan="5">
                            <TextareaComponent
                                id="tab10-textarea-21"
                                :model.sync="dataObject.check_the_latest_posts_2.data"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['直近投稿内容確認']"
                                :config="inputConfig.check_the_latest_posts_2"
                                :isPreview="isPreview"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.check_the_latest_posts_2_first)"
                                v-model="dataObject.check_the_latest_posts_2.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('check_the_latest_posts_2', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.check_the_latest_posts_2_secondary)"
                                v-model="dataObject.check_the_latest_posts_2.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('check_the_latest_posts_2', 'secondary')"
                            />
                        </td>
                    </tr>
                    <tr v-if="SWITCH_FIELD_TAB_10(dataObject, isPreview)['直近投稿内容確認']">
                        <td colspan="5">
                            <TextareaComponent
                                id="tab10-textarea-22"
                                :model.sync="dataObject.check_the_latest_posts_3.data"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['直近投稿内容確認']"
                                :config="inputConfig.check_the_latest_posts_3"
                                :isPreview="isPreview"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.check_the_latest_posts_3_first)"
                                v-model="dataObject.check_the_latest_posts_3.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('check_the_latest_posts_3', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.check_the_latest_posts_3_secondary)"
                                v-model="dataObject.check_the_latest_posts_3.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('check_the_latest_posts_3', 'secondary')"
                            />
                        </td>
                    </tr>
                </template>
                <tr v-if="SWITCH_FIELD_TAB_10(dataObject, isPreview)['＜重複・懸賞チェック＞その他条件（別資料）']">
                    <td colspan="2" class="bg-color4">
                        <div class="d-flex flex-wrap align-items-center">
                            <b-form-checkbox
                                v-if="!isPreview && !isRolePartner"
                                switch
                                v-model="SWITCH_FIELD_TAB_10(dataObject)['＜重複・懸賞チェック＞その他条件（別資料）']"
                                @change="
                                    toggleCommonSwitch($event, {
                                        other_condition_prize_check: dataObject.other_condition_prize_check
                                    })
                                "
                            />
                            その他条件（別資料）
                        </div>
                    </td>
                    <td colspan="5">
                        <TextareaComponent
                            id="tab10-textarea-23"
                            :model.sync="dataObject.other_condition_prize_check.data"
                            :disabled="isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['＜重複・懸賞チェック＞その他条件（別資料）']"
                            :config="inputConfig.other_condition_prize_check"
                            :isPreview="isPreview"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.other_condition_prize_check_first)"
                            v-model="dataObject.other_condition_prize_check.first_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('other_condition_prize_check', 'first')"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.other_condition_prize_check_secondary)"
                            v-model="dataObject.other_condition_prize_check.secondary_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('other_condition_prize_check', 'secondary')"
                        />
                    </td>
                </tr>
                <tr v-if="SWITCH_FIELD_TAB_10(dataObject, isPreview)['＜重複・懸賞チェック＞その他先_10']">
                    <td class="bg-color4" colspan="2">
                        <b-form-checkbox
                            v-if="!isPreview && !isRolePartner"
                            class="mb-1"
                            switch
                            v-model="SWITCH_FIELD_TAB_10(dataObject)['＜重複・懸賞チェック＞その他先_10']"
                            @change="toggleCommonSwitch($event, { free_block_duplicate_prize_check: dataObject.free_block_duplicate_prize_check })"
                        />
                        <b-form-input
                            v-model="dataObject.free_block_duplicate_prize_check.title"
                            :disabled="isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['＜重複・懸賞チェック＞その他先_10']"
                            :class="`${isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['＜重複・懸賞チェック＞その他先_10'] ? 'disabled_cursor' : ''} w-100`"
                        ></b-form-input>
                    </td>
                    <td colspan="5">
                        <div
                            v-if="isNotCheckBoxPartner || isDisabled"
                            class="box--text__disabled"
                            v-html="dataObject.free_block_duplicate_prize_check.data"
                        ></div>
                        <Editor
                            v-else
                            :id="`editor-＜重複・懸賞チェック＞その他先_10-${idTab}`"
                            :model.sync="dataObject.free_block_duplicate_prize_check.data"
                            :configInit="{
                                disabled: forceEnableEditors
                                    ? false
                                    : isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['＜重複・懸賞チェック＞その他先_10'],
                                is_autoresize_on: true
                            }"
                        />
                    </td>
                </tr>
                <template v-if="checkOrder">
                    <tr>
                        <th :colspan="lengthHeaders">＜条件チェック＞</th>
                    </tr>
                    <tr v-if="SWITCH_FIELD_TAB_10(dataObject, isPreview)['＜条件チェック＞対象ファイル']">
                        <td colspan="2" class="bg-color4">
                            <div class="d-flex flex-wrap align-items-center">
                                <b-form-checkbox
                                    v-if="!isPreview && !isRolePartner"
                                    switch
                                    v-model="SWITCH_FIELD_TAB_10(dataObject)['＜条件チェック＞対象ファイル']"
                                    @change="
                                        toggleCommonSwitch($event, {
                                            target_file_status_check: dataObject.target_file_status_check
                                        })
                                    "
                                />
                                対象ファイル
                            </div>
                        </td>
                        <td colspan="5">
                            <CommonMultiselect
                                v-model="dataObject.target_file_status_check.data"
                                :options.sync="option.target_file_status_check"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['＜条件チェック＞対象ファイル']"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.target_file_status_check_first)"
                                v-model="dataObject.target_file_status_check.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('target_file_status_check', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.target_file_status_check_secondary)"
                                v-model="dataObject.target_file_status_check.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('target_file_status_check', 'secondary')"
                            />
                        </td>
                    </tr>
                    <tr v-if="SWITCH_FIELD_TAB_10(dataObject, isPreview)['＜条件チェック＞期間条件（抽出対象期間）']">
                        <td colspan="2" class="bg-color4">
                            <div class="d-flex flex-wrap align-items-center">
                                <b-form-checkbox
                                    v-if="!isPreview && !isRolePartner"
                                    switch
                                    v-model="SWITCH_FIELD_TAB_10(dataObject)['＜条件チェック＞期間条件（抽出対象期間）']"
                                    @change="
                                        toggleCommonSwitch($event, {
                                            period_conditions_extracted: dataObject.period_conditions_extracted
                                        })
                                    "
                                />
                                期間条件（抽出対象期間）<br />
                                ※データのDLは全期間で実施してデータ上で抽出
                            </div>
                        </td>
                        <td colspan="5">
                            <div
                                :class="`box--text__disabled ${isNotCheckBoxPartner || isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['＜条件チェック＞期間条件（抽出対象期間）'] ? 'disabled_input' : ''}`"
                                :style="{
                                    'background-color':
                                        isNotCheckBoxPartner ||
                                        isDisabled ||
                                        !SWITCH_FIELD_TAB_10(dataObject)['＜条件チェック＞期間条件（抽出対象期間）']
                                            ? ''
                                            : '#ffffff',
                                    'min-height': '37px'
                                }"
                            >
                                {{ formatDateTimeJapanese(detailBeginForDocument.campaign_start_date) }}～{{
                                    formatDateTimeJapanese(detailBeginForDocument.campaign_end_date)
                                }}
                            </div>
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.period_conditions_extracted_first)"
                                v-model="dataObject.period_conditions_extracted.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('period_conditions_extracted', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.period_conditions_extracted_secondary)"
                                v-model="dataObject.period_conditions_extracted.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('period_conditions_extracted', 'secondary')"
                            />
                        </td>
                    </tr>
                    <template v-if="SWITCH_FIELD_TAB_10(dataObject, isPreview)['＜条件チェック＞最終納品データの形指定有無']">
                        <tr>
                            <td colspan="2" rowspan="2" class="bg-color4">
                                <div class="d-flex flex-wrap align-items-center">
                                    <b-form-checkbox
                                        v-if="!isPreview && !isRolePartner"
                                        switch
                                        v-model="SWITCH_FIELD_TAB_10(dataObject)['＜条件チェック＞最終納品データの形指定有無']"
                                        @change="
                                            toggleCommonSwitch($event, {
                                                specifies_the_data_format: dataObject.specifies_the_data_format,
                                                specifies_the_data_format_detail: dataObject.specifies_the_data_format_detail
                                            })
                                        "
                                    />
                                    最終納品データの形指定有無
                                </div>
                            </td>
                            <td colspan="5">
                                <CommonMultiselect
                                    v-model="dataObject.specifies_the_data_format.data"
                                    :options.sync="option.specifies_the_data_format"
                                    :disabled="isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['＜条件チェック＞最終納品データの形指定有無']"
                                />
                            </td>
                            <td>
                                <CommonCheckbox
                                    :disabled="isNotCheckBoxPartner || (processingFields && processingFields.specifies_the_data_format_first)"
                                    v-model="dataObject.specifies_the_data_format.first_check"
                                    :currentUser="currentUser"
                                    @input="handleCheckBoxValue('specifies_the_data_format', 'first')"
                                />
                            </td>
                            <td>
                                <CommonCheckbox
                                    :disabled="isNotCheckBoxPartner || (processingFields && processingFields.specifies_the_data_format_secondary)"
                                    v-model="dataObject.specifies_the_data_format.secondary_check"
                                    :currentUser="currentUser"
                                    @input="handleCheckBoxValue('specifies_the_data_format', 'secondary')"
                                />
                            </td>
                        </tr>
                        <tr>
                            <td colspan="5">
                                <TextareaComponent
                                    id="tab10-textarea-24"
                                    :model.sync="dataObject.specifies_the_data_format_detail.data"
                                    :disabled="isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['＜条件チェック＞最終納品データの形指定有無']"
                                    :config="inputConfig.specifies_the_data_format_detail"
                                    :isPreview="isPreview"
                                />
                            </td>
                            <td>
                                <CommonCheckbox
                                    :disabled="isNotCheckBoxPartner || (processingFields && processingFields.specifies_the_data_format_detail_first)"
                                    v-model="dataObject.specifies_the_data_format_detail.first_check"
                                    :currentUser="currentUser"
                                    @input="handleCheckBoxValue('specifies_the_data_format_detail', 'first')"
                                />
                            </td>
                            <td>
                                <CommonCheckbox
                                    :disabled="
                                        isNotCheckBoxPartner || (processingFields && processingFields.specifies_the_data_format_detail_secondary)
                                    "
                                    v-model="dataObject.specifies_the_data_format_detail.secondary_check"
                                    :currentUser="currentUser"
                                    @input="handleCheckBoxValue('specifies_the_data_format_detail', 'secondary')"
                                />
                            </td>
                        </tr>
                    </template>
                    <tr v-if="SWITCH_FIELD_TAB_10(dataObject, isPreview)['＜条件チェック＞その他条件']">
                        <td colspan="2" class="bg-color4">
                            <div class="d-flex flex-wrap align-items-center">
                                <b-form-checkbox
                                    v-if="!isPreview && !isRolePartner"
                                    switch
                                    v-model="SWITCH_FIELD_TAB_10(dataObject)['＜条件チェック＞その他条件']"
                                    @change="
                                        toggleCommonSwitch($event, {
                                            other_conditions_status_check: dataObject.other_conditions_status_check
                                        })
                                    "
                                />
                                その他条件
                            </div>
                        </td>
                        <td colspan="5">
                            <TextareaComponent
                                id="tab10-textarea-25"
                                :model.sync="dataObject.other_conditions_status_check.data"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['＜条件チェック＞その他条件']"
                                :config="inputConfig.other_conditions_status_check"
                                :isPreview="isPreview"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.other_conditions_status_check_first)"
                                v-model="dataObject.other_conditions_status_check.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('other_conditions_status_check', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.other_conditions_status_check_secondary)"
                                v-model="dataObject.other_conditions_status_check.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('other_conditions_status_check', 'secondary')"
                            />
                        </td>
                    </tr>
                    <tr v-if="SWITCH_FIELD_TAB_10(dataObject, isPreview)['＜条件チェック＞その他先_10']">
                        <td class="bg-color4" colspan="2">
                            <b-form-checkbox
                                v-if="!isPreview && !isRolePartner"
                                class="mb-1"
                                switch
                                v-model="SWITCH_FIELD_TAB_10(dataObject)['＜条件チェック＞その他先_10']"
                                @change="toggleCommonSwitch($event, { free_block_condition_check: dataObject.free_block_condition_check })"
                            />
                            <b-form-input
                                v-model="dataObject.free_block_condition_check.title"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['＜条件チェック＞その他先_10']"
                                :class="`${isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['＜条件チェック＞その他先_10'] ? 'disabled_cursor' : ''} w-100`"
                            ></b-form-input>
                        </td>
                        <td colspan="5">
                            <div
                                v-if="isNotCheckBoxPartner || isDisabled"
                                class="box--text__disabled"
                                v-html="dataObject.free_block_condition_check.data"
                            ></div>
                            <Editor
                                v-else
                                :id="`editor-＜条件チェック＞その他先_10-${idTab}`"
                                :model.sync="dataObject.free_block_condition_check.data"
                                :configInit="{
                                    disabled: forceEnableEditors
                                        ? false
                                        : isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['＜条件チェック＞その他先_10'],
                                    is_autoresize_on: true
                                }"
                            />
                        </td>
                    </tr>
                </template>

                <!-- <tr>
                    <th :colspan="lengthHeaders">＜条件チェック＞</th>
                </tr>
                <tr>
                    <td colspan="2" class="bg-color4">対象ファイル</td>
                    <td colspan="5">WEBCASフォーム／その他フォーム／支給データ</td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td colspan="2" class="bg-color4">
                        期間条件（抽出対象期間）<br />
                        ※データのDLは全期間で実施してデータ上で抽出
                    </td>
                    <td colspan="5">{{ staticPeriodConditionText }}</td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td colspan="2" rowspan="2" class="bg-color4">最終納品データの形指定有無</td>
                    <td colspan="5"></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td colspan="5">&lt;ありの場合詳細記入&gt;</td>
                    <td></td>
                    <td></td>
                    <td style="border: none; white-space: nowrap"></td>
                </tr>
                <tr>
                    <td colspan="2" class="bg-color4">その他条件</td>
                    <td colspan="5"></td>
                    <td></td>
                    <td></td>
                </tr> -->

                <tr v-if="SWITCH_FIELD_TAB_10(dataObject, isPreview)['＜重複・照合チェック＞']">
                    <th :colspan="lengthHeaders">
                        <div class="d-flex flex-wrap align-items-center">
                            <b-form-checkbox
                                v-if="!isPreview && !isRolePartner"
                                switch
                                v-model="SWITCH_FIELD_TAB_10(dataObject)['＜重複・照合チェック＞']"
                                @change="
                                    toggleCommonSwitch($event, {
                                        matching_items: dataObject.matching_items,
                                        condition_maching: dataObject.condition_maching,
                                        condition_maching_data: dataObject.condition_maching_data,
                                        overlap_condition_id_1: dataObject.overlap_condition_id_1,
                                        overlap_condition_id_2: dataObject.overlap_condition_id_2,
                                        overlap_condition_same_house_1: dataObject.overlap_condition_same_house_1,
                                        overlap_condition_same_house_2: dataObject.overlap_condition_same_house_2,
                                        overlap_condition_same_person_1: dataObject.overlap_condition_same_person_1,
                                        overlap_condition_same_preson_2: dataObject.overlap_condition_same_preson_2,
                                        overlap_condition_others: dataObject.overlap_condition_others,
                                        free_block_duplicate_collation_check: dataObject.free_block_duplicate_collation_check
                                    })
                                "
                            />
                            ＜重複・照合チェック＞
                        </div>
                    </th>
                </tr>
                <tr v-if="SWITCH_FIELD_TAB_10(dataObject, isPreview)['照合項目']">
                    <td colspan="2" class="bg-color4">
                        <div class="d-flex flex-wrap align-items-center">
                            <b-form-checkbox
                                v-if="!isPreview && !isRolePartner"
                                switch
                                v-model="SWITCH_FIELD_TAB_10(dataObject)['照合項目']"
                                @change="
                                    toggleCommonSwitch($event, {
                                        matching_items: dataObject.matching_items
                                    })
                                "
                            />
                            照合項目
                        </div>
                    </td>
                    <td colspan="5">
                        <CommonMultiselect
                            v-model="dataObject.matching_items.data"
                            :options.sync="option.matching_items"
                            :disabled="isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['照合項目']"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.matching_items_first)"
                            v-model="dataObject.matching_items.first_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('matching_items', 'first')"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.matching_items_secondary)"
                            v-model="dataObject.matching_items.secondary_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('matching_items', 'secondary')"
                        />
                    </td>
                </tr>
                <template v-if="SWITCH_FIELD_TAB_10(dataObject, isPreview)['照合条件']">
                    <tr>
                        <td rowspan="2" class="bg-color4">
                            <div class="d-flex flex-wrap align-items-center">
                                <b-form-checkbox
                                    v-if="!isPreview && !isRolePartner"
                                    switch
                                    v-model="SWITCH_FIELD_TAB_10(dataObject)['照合条件']"
                                    @change="
                                        toggleCommonSwitch($event, {
                                            condition_maching: dataObject.condition_maching,
                                            condition_maching_data: dataObject.condition_maching_data
                                        })
                                    "
                                />
                                照合条件
                            </div>
                        </td>
                        <td rowspan="2" class="bg-color4">ID</td>
                        <td colspan="5">
                            <CommonMultiselect
                                v-model="dataObject.condition_maching.data"
                                :options.sync="option.condition_maching"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['照合条件']"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.condition_maching_first)"
                                v-model="dataObject.condition_maching.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('condition_maching', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.condition_maching_secondary)"
                                v-model="dataObject.condition_maching.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('condition_maching', 'secondary')"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2">
                            <TextareaComponent
                                id="tab10-textarea-26"
                                :model.sync="dataObject.condition_maching_data.data.text1"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['照合条件']"
                                :config="inputConfig.condition_maching_data"
                                :isPreview="isPreview"
                            />
                        </td>
                        <td colspan="3">
                            <CommonMultiselect
                                v-model="dataObject.condition_maching_data.data.text2"
                                :options.sync="option.condition_maching_data"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['照合条件']"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.condition_maching_data_first)"
                                v-model="dataObject.condition_maching_data.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('condition_maching_data', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.condition_maching_data_secondary)"
                                v-model="dataObject.condition_maching_data.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('condition_maching_data', 'secondary')"
                            />
                        </td>
                    </tr>
                </template>

                <template v-if="SWITCH_FIELD_TAB_10(dataObject, isPreview)['＜重複・照合チェック＞重複条件']">
                    <tr>
                        <td
                            :rowspan="
                                calculateRowspan(SWITCH_FIELD_TAB_10(dataObject, isPreview), CONFIG_ROWSPAN_TAB_10['＜重複・照合チェック＞重複条件'])
                            "
                            class="bg-color4"
                        >
                            <div class="d-flex flex-wrap align-items-center">
                                <b-form-checkbox
                                    v-if="!isPreview && !isRolePartner"
                                    switch
                                    v-model="SWITCH_FIELD_TAB_10(dataObject)['＜重複・照合チェック＞重複条件']"
                                    @change="
                                        toggleCommonSwitch($event, {
                                            overlap_condition_id_1: dataObject.overlap_condition_id_1,
                                            overlap_condition_id_2: dataObject.overlap_condition_id_2,
                                            overlap_condition_same_house_1: dataObject.overlap_condition_same_house_1,
                                            overlap_condition_same_house_2: dataObject.overlap_condition_same_house_2,
                                            overlap_condition_same_person_1: dataObject.overlap_condition_same_person_1,
                                            overlap_condition_same_preson_2: dataObject.overlap_condition_same_preson_2
                                        })
                                    "
                                />
                                重複条件
                            </div>
                        </td>

                        <template v-if="SWITCH_FIELD_TAB_10(dataObject, isPreview)['指定ID']">
                            <td rowspan="2" class="bg-color4">
                                <div class="d-flex flex-wrap align-items-center">
                                    <b-form-checkbox
                                        v-if="!isPreview && !isRolePartner"
                                        switch
                                        v-model="SWITCH_FIELD_TAB_10(dataObject)['指定ID']"
                                        :disabled="!SWITCH_FIELD_TAB_10(dataObject)['＜重複・照合チェック＞重複条件']"
                                        @change="
                                            toggleCommonSwitch($event, {
                                                overlap_condition_id_1: dataObject.overlap_condition_id_1,
                                                overlap_condition_id_2: dataObject.overlap_condition_id_2
                                            })
                                        "
                                    />
                                    指定ID
                                </div>
                            </td>
                            <td colspan="5">
                                <CommonMultiselect
                                    v-model="dataObject.overlap_condition_id_1.data"
                                    :options.sync="option.overlap_condition_id_1"
                                    :disabled="isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['指定ID']"
                                />
                            </td>
                            <td>
                                <CommonCheckbox
                                    :disabled="isNotCheckBoxPartner || (processingFields && processingFields.overlap_condition_id_1_first)"
                                    v-model="dataObject.overlap_condition_id_1.first_check"
                                    :currentUser="currentUser"
                                    @input="handleCheckBoxValue('overlap_condition_id_1', 'first')"
                                />
                            </td>
                            <td>
                                <CommonCheckbox
                                    :disabled="isNotCheckBoxPartner || (processingFields && processingFields.overlap_condition_id_1_secondary)"
                                    v-model="dataObject.overlap_condition_id_1.secondary_check"
                                    :currentUser="currentUser"
                                    @input="handleCheckBoxValue('overlap_condition_id_1', 'secondary')"
                                />
                            </td>
                        </template>
                    </tr>

                    <tr v-if="SWITCH_FIELD_TAB_10(dataObject, isPreview)['指定ID']">
                        <td colspan="5">
                            <CommonMultiselect
                                v-model="dataObject.overlap_condition_id_2.data"
                                :options.sync="option.overlap_condition_id_2"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['指定ID']"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.overlap_condition_id_2_first)"
                                v-model="dataObject.overlap_condition_id_2.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('overlap_condition_id_2', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.overlap_condition_id_2_secondary)"
                                v-model="dataObject.overlap_condition_id_2.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('overlap_condition_id_2', 'secondary')"
                            />
                        </td>
                    </tr>

                    <tr v-if="SWITCH_FIELD_TAB_10(dataObject, isPreview)['同一世帯_10']">
                        <td rowspan="2" class="bg-color4">
                            <div class="d-flex flex-wrap align-items-center">
                                <b-form-checkbox
                                    v-if="!isPreview && !isRolePartner"
                                    switch
                                    v-model="SWITCH_FIELD_TAB_10(dataObject)['同一世帯_10']"
                                    :disabled="!SWITCH_FIELD_TAB_10(dataObject)['＜重複・照合チェック＞重複条件']"
                                    @change="
                                        toggleCommonSwitch($event, {
                                            overlap_condition_same_house_1: dataObject.overlap_condition_same_house_1,
                                            overlap_condition_same_house_2: dataObject.overlap_condition_same_house_2
                                        })
                                    "
                                />
                                同一世帯
                            </div>
                        </td>
                        <td colspan="5">
                            <TextareaComponent
                                id="tab10-textarea-27"
                                :model.sync="dataObject.overlap_condition_same_house_1.data"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['同一世帯_10']"
                                :config="inputConfig.overlap_condition_same_house_1"
                                :isPreview="isPreview"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.overlap_condition_same_house_1_first)"
                                v-model="dataObject.overlap_condition_same_house_1.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('overlap_condition_same_house_1', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.overlap_condition_same_house_1_secondary)"
                                v-model="dataObject.overlap_condition_same_house_1.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('overlap_condition_same_house_1', 'secondary')"
                            />
                        </td>
                    </tr>
                    <tr v-if="SWITCH_FIELD_TAB_10(dataObject, isPreview)['同一世帯_10']">
                        <td colspan="5">
                            <CommonMultiselect
                                v-model="dataObject.overlap_condition_same_house_2.data"
                                :options.sync="option.overlap_condition_same_house_2"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['同一世帯_10']"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.overlap_condition_same_house_2_first)"
                                v-model="dataObject.overlap_condition_same_house_2.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('overlap_condition_same_house_2', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.overlap_condition_same_house_2_secondary)"
                                v-model="dataObject.overlap_condition_same_house_2.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('overlap_condition_same_house_2', 'secondary')"
                            />
                        </td>
                    </tr>

                    <tr v-if="SWITCH_FIELD_TAB_10(dataObject, isPreview)['同一人物_10']">
                        <td rowspan="2" class="bg-color4">
                            <div class="d-flex flex-wrap align-items-center">
                                <b-form-checkbox
                                    v-if="!isPreview && !isRolePartner"
                                    switch
                                    v-model="SWITCH_FIELD_TAB_10(dataObject)['同一人物_10']"
                                    :disabled="!SWITCH_FIELD_TAB_10(dataObject)['＜重複・照合チェック＞重複条件']"
                                    @change="
                                        toggleCommonSwitch($event, {
                                            overlap_condition_same_person_1: dataObject.overlap_condition_same_person_1,
                                            overlap_condition_same_preson_2: dataObject.overlap_condition_same_preson_2
                                        })
                                    "
                                />
                                同一人物
                            </div>
                        </td>
                        <td colspan="5">
                            <TextareaComponent
                                id="tab10-textarea-28"
                                :model.sync="dataObject.overlap_condition_same_person_1.data"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['同一人物_10']"
                                :config="inputConfig.overlap_condition_same_person_1"
                                :isPreview="isPreview"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.overlap_condition_same_person_1_first)"
                                v-model="dataObject.overlap_condition_same_person_1.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('overlap_condition_same_person_1', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.overlap_condition_same_person_1_secondary)"
                                v-model="dataObject.overlap_condition_same_person_1.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('overlap_condition_same_person_1', 'secondary')"
                            />
                        </td>
                    </tr>
                    <tr v-if="SWITCH_FIELD_TAB_10(dataObject, isPreview)['同一人物_10']">
                        <td colspan="5">
                            <CommonMultiselect
                                v-model="dataObject.overlap_condition_same_preson_2.data"
                                :options.sync="option.overlap_condition_same_preson_2"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['同一人物_10']"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.overlap_condition_same_preson_2_first)"
                                v-model="dataObject.overlap_condition_same_preson_2.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('overlap_condition_same_preson_2', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.overlap_condition_same_preson_2_secondary)"
                                v-model="dataObject.overlap_condition_same_preson_2.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('overlap_condition_same_preson_2', 'secondary')"
                            />
                        </td>
                    </tr>
                </template>
                <tr v-if="SWITCH_FIELD_TAB_10(dataObject, isPreview)['＜重複・照合チェック＞その他条件']">
                    <td colspan="2" class="bg-color4">
                        <div class="d-flex flex-wrap align-items-center">
                            <b-form-checkbox
                                v-if="!isPreview && !isRolePartner"
                                switch
                                v-model="SWITCH_FIELD_TAB_10(dataObject)['＜重複・照合チェック＞その他条件']"
                                @change="
                                    toggleCommonSwitch($event, {
                                        overlap_condition_others: dataObject.overlap_condition_others
                                    })
                                "
                            />
                            その他条件
                        </div>
                    </td>
                    <td colspan="5">
                        <TextareaComponent
                            id="tab10-textarea-29"
                            :model.sync="dataObject.overlap_condition_others.data"
                            :disabled="isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['＜重複・照合チェック＞その他条件']"
                            :config="inputConfig.overlap_condition_others"
                            :isPreview="isPreview"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.overlap_condition_others_first)"
                            v-model="dataObject.overlap_condition_others.first_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('overlap_condition_others', 'first')"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.overlap_condition_others_secondary)"
                            v-model="dataObject.overlap_condition_others.secondary_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('overlap_condition_others', 'secondary')"
                        />
                    </td>
                </tr>
                <tr v-if="SWITCH_FIELD_TAB_10(dataObject, isPreview)['＜重複・照合チェック＞その他先_10']">
                    <td class="bg-color4" colspan="2">
                        <b-form-checkbox
                            v-if="!isPreview && !isRolePartner"
                            class="mb-1"
                            switch
                            v-model="SWITCH_FIELD_TAB_10(dataObject)['＜重複・照合チェック＞その他先_10']"
                            @change="
                                toggleCommonSwitch($event, { free_block_duplicate_collation_check: dataObject.free_block_duplicate_collation_check })
                            "
                        />
                        <b-form-input
                            v-model="dataObject.free_block_duplicate_collation_check.title"
                            :disabled="isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['＜重複・照合チェック＞その他先_10']"
                            :class="`${isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['＜重複・照合チェック＞その他先_10'] ? 'disabled_cursor' : ''} w-100`"
                        ></b-form-input>
                    </td>
                    <td colspan="5">
                        <div
                            v-if="isNotCheckBoxPartner || isDisabled"
                            class="box--text__disabled"
                            v-html="dataObject.free_block_duplicate_collation_check.data"
                        ></div>
                        <Editor
                            v-else
                            :id="`editor-＜重複・照合チェック＞その他先_10-${idTab}`"
                            :model.sync="dataObject.free_block_duplicate_collation_check.data"
                            :configInit="{
                                disabled: forceEnableEditors
                                    ? false
                                    : isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['＜重複・照合チェック＞その他先_10'],
                                is_autoresize_on: true
                            }"
                        />
                    </td>
                </tr>
                <tr>
                    <th :colspan="lengthHeaders">＜不備チェック＞</th>
                </tr>
                <tr v-if="SWITCH_FIELD_TAB_10(dataObject, isPreview)['名前不備確認']">
                    <td colspan="2" class="bg-color4">
                        <div class="d-flex flex-wrap align-items-center">
                            <b-form-checkbox
                                v-if="!isPreview && !isRolePartner"
                                switch
                                v-model="SWITCH_FIELD_TAB_10(dataObject)['名前不備確認']"
                                @change="
                                    toggleCommonSwitch($event, {
                                        confirm_error_name: dataObject.confirm_error_name
                                    })
                                "
                            />
                            名前不備確認
                        </div>
                    </td>
                    <td colspan="5">
                        <TextareaComponent
                            id="tab10-textarea-30"
                            :model.sync="dataObject.confirm_error_name.data"
                            :disabled="isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['名前不備確認']"
                            :config="inputConfig.confirm_error_name"
                            :isPreview="isPreview"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.confirm_error_name_first)"
                            v-model="dataObject.confirm_error_name.first_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('confirm_error_name', 'first')"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.confirm_error_name_secondary)"
                            v-model="dataObject.confirm_error_name.secondary_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('confirm_error_name', 'secondary')"
                        />
                    </td>
                </tr>
                <template v-if="SWITCH_FIELD_TAB_10(dataObject, isPreview)['住所不備確認']">
                    <tr>
                        <td colspan="2" rowspan="2" class="bg-color4">
                            <div class="d-flex flex-wrap align-items-center">
                                <b-form-checkbox
                                    v-if="!isPreview && !isRolePartner"
                                    switch
                                    v-model="SWITCH_FIELD_TAB_10(dataObject)['住所不備確認']"
                                    @change="
                                        toggleCommonSwitch($event, {
                                            address_verification_1: dataObject.address_verification_1,
                                            address_verification_2: dataObject.address_verification_2
                                        })
                                    "
                                />
                                住所不備確認
                            </div>
                        </td>
                        <td colspan="5">
                            <TextareaComponent
                                id="tab10-textarea-31"
                                :model.sync="dataObject.address_verification_1.data"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['住所不備確認']"
                                :config="inputConfig.address_verification_1"
                                :isPreview="isPreview"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.address_verification_1_first)"
                                v-model="dataObject.address_verification_1.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('address_verification_1', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.address_verification_1_secondary)"
                                v-model="dataObject.address_verification_1.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('address_verification_1', 'secondary')"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td colspan="5">
                            <CommonMultiselect
                                v-model="dataObject.address_verification_2.data"
                                :options.sync="option.address_verification_2"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['住所不備確認']"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.address_verification_2_first)"
                                v-model="dataObject.address_verification_2.first_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('address_verification_2', 'first')"
                            />
                        </td>
                        <td>
                            <CommonCheckbox
                                :disabled="isNotCheckBoxPartner || (processingFields && processingFields.address_verification_2_secondary)"
                                v-model="dataObject.address_verification_2.secondary_check"
                                :currentUser="currentUser"
                                @input="handleCheckBoxValue('address_verification_2', 'secondary')"
                            />
                        </td>
                    </tr>
                </template>
                <tr v-if="SWITCH_FIELD_TAB_10(dataObject, isPreview)['電話番号不備確認']">
                    <td colspan="2" class="bg-color4">
                        <div class="d-flex flex-wrap align-items-center">
                            <b-form-checkbox
                                v-if="!isPreview && !isRolePartner"
                                switch
                                v-model="SWITCH_FIELD_TAB_10(dataObject)['電話番号不備確認']"
                                @change="
                                    toggleCommonSwitch($event, {
                                        confirm_phone_number_is_incomplete: dataObject.confirm_phone_number_is_incomplete
                                    })
                                "
                            />
                            電話番号不備確認
                        </div>
                    </td>
                    <td colspan="5">
                        <TextareaComponent
                            id="tab10-textarea-32"
                            :model.sync="dataObject.confirm_phone_number_is_incomplete.data"
                            :disabled="isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['電話番号不備確認']"
                            :config="inputConfig.confirm_phone_number_is_incomplete"
                            :isPreview="isPreview"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.confirm_phone_number_is_incomplete_first)"
                            v-model="dataObject.confirm_phone_number_is_incomplete.first_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('confirm_phone_number_is_incomplete', 'first')"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.confirm_phone_number_is_incomplete_secondary)"
                            v-model="dataObject.confirm_phone_number_is_incomplete.secondary_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('confirm_phone_number_is_incomplete', 'secondary')"
                        />
                    </td>
                </tr>
                <tr v-if="SWITCH_FIELD_TAB_10(dataObject, isPreview)['メールアドレス不備確認']">
                    <td colspan="2" class="bg-color4">
                        <div class="d-flex flex-wrap align-items-center">
                            <b-form-checkbox
                                v-if="!isPreview && !isRolePartner"
                                switch
                                v-model="SWITCH_FIELD_TAB_10(dataObject)['メールアドレス不備確認']"
                                @change="
                                    toggleCommonSwitch($event, {
                                        confirm_email_address_is_incomplete: dataObject.confirm_email_address_is_incomplete
                                    })
                                "
                            />
                            メールアドレス不備確認
                        </div>
                    </td>
                    <td colspan="5">
                        <TextareaComponent
                            id="tab10-textarea-33"
                            :model.sync="dataObject.confirm_email_address_is_incomplete.data"
                            :disabled="isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['メールアドレス不備確認']"
                            :config="inputConfig.confirm_email_address_is_incomplete"
                            :isPreview="isPreview"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.confirm_email_address_is_incomplete_first)"
                            v-model="dataObject.confirm_email_address_is_incomplete.first_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('confirm_email_address_is_incomplete', 'first')"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.confirm_email_address_is_incomplete_secondary)"
                            v-model="dataObject.confirm_email_address_is_incomplete.secondary_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('confirm_email_address_is_incomplete', 'secondary')"
                        />
                    </td>
                </tr>
                <tr v-if="SWITCH_FIELD_TAB_10(dataObject, isPreview)['＜不備チェック＞その他']">
                    <td colspan="2" class="bg-color4">
                        <div class="d-flex flex-wrap align-items-center">
                            <b-form-checkbox
                                v-if="!isPreview && !isRolePartner"
                                switch
                                v-model="SWITCH_FIELD_TAB_10(dataObject)['＜不備チェック＞その他']"
                                @change="
                                    toggleCommonSwitch($event, {
                                        other_errors: dataObject.other_errors
                                    })
                                "
                            />
                            その他
                        </div>
                    </td>
                    <td colspan="5">
                        <TextareaComponent
                            id="tab10-textarea-34"
                            :model.sync="dataObject.other_errors.data"
                            :disabled="isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['＜不備チェック＞その他']"
                            :config="inputConfig.other_errors"
                            :isPreview="isPreview"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.other_errors_first)"
                            v-model="dataObject.other_errors.first_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('other_errors', 'first')"
                        />
                    </td>
                    <td>
                        <CommonCheckbox
                            :disabled="isNotCheckBoxPartner || (processingFields && processingFields.other_errors_secondary)"
                            v-model="dataObject.other_errors.secondary_check"
                            :currentUser="currentUser"
                            @input="handleCheckBoxValue('other_errors', 'secondary')"
                        />
                    </td>
                </tr>
                <tr v-if="SWITCH_FIELD_TAB_10(dataObject, isPreview)['フリーブロックその他先']">
                    <td class="bg-color4" colspan="2">
                        <b-form-checkbox
                            v-if="!isPreview && !isRolePartner"
                            class="mb-1"
                            switch
                            v-model="SWITCH_FIELD_TAB_10(dataObject)['フリーブロックその他先']"
                            @change="toggleCommonSwitch($event, { free_block_other: dataObject.free_block_other })"
                        />
                        <b-form-input
                            v-model="dataObject.free_block_other.title"
                            :disabled="isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['フリーブロックその他先']"
                            :class="`${isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['フリーブロックその他先'] ? 'disabled_cursor' : ''}`"
                        ></b-form-input>
                    </td>
                    <td colspan="5">
                        <div v-if="isNotCheckBoxPartner || isDisabled" class="box--text__disabled" v-html="dataObject.free_block_other.data"></div>
                        <Editor
                            v-else
                            :id="`editor-${idTab}`"
                            :model.sync="dataObject.free_block_other.data"
                            :configInit="{
                                disabled: forceEnableEditors ? false : isDisabled || !SWITCH_FIELD_TAB_10(dataObject)['フリーブロックその他先'],
                                is_autoresize_on: true
                            }"
                        />
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import CommonMultiselect from './CommonMultiselect.vue';
import Editor from '@/components/Editor/main.vue';
import editorDelayMixin from '@/mixins/editorDelayMixin';
import CommonCheckbox from './CommonCheckbox.vue';
import TextareaComponent from '@/components/Textarea/main.vue';

import { InputText } from '@/components/Input';
import { STR_DATE } from '@/utils/format';
import {
    formatDateToJapanese,
    formatDateTimeJapanese,
    toggleCommonSwitch,
    isRolePartner,
    onHandleDataCheckValueForPartner,
    calculateRowspan
} from '@/views/pages/require/handlers';
import { CONFIG_TABLE_TAB_10 } from '@/views/pages/require/constant-table';
import { SWITCH_FIELD_TAB_10, configHelperOptions, CONFIG_INPUT_TAB_10, CONFIG_ROWSPAN_TAB_10 } from '@/views/pages/require/const-field-tab';

export default {
    name: 'Tab10Require',
    mixins: [editorDelayMixin],
    props: {
        isNotCheckBoxPartner: {
            type: Boolean,
            default: () => false
        },
        keyTab: {
            type: [String],
            default: ''
        },
        idTab: {
            type: [String, Number],
            default: ''
        },
        checkOrder: {
            type: Boolean,
            required: false
        },
        dataObject: {
            type: Object,
            required: false
        },
        currentUser: {
            type: Object,
            required: false
        },
        detailBeginForDocument: {
            type: Object,
            required: false
        },
        isDisabled: {
            type: Boolean,
            required: false
        },
        isPreview: {
            type: Boolean,
            required: false
        },
        processingFields: {
            type: Object,
            default: () => ({})
        }
    },
    components: {
        CommonMultiselect,
        CommonCheckbox,
        InputText,
        TextareaComponent,
        Editor
    },
    computed: {
        lengthHeaders() {
            return CONFIG_TABLE_TAB_10().headers.reduce((acc, col) => acc + (col.colspan || 1), 0);
        }
    },
    data() {
        return {
            staticPeriodConditionText: '年　月　日（　）●：●～　年　月　日（　）●：●',
            customFormatDate: STR_DATE,
            option: configHelperOptions.optionTab10,
            CONFIG_ROWSPAN_TAB_10,
            isRolePartner: isRolePartner(),
            inputConfig: CONFIG_INPUT_TAB_10()
        };
    },
    methods: {
        formatDateToJapanese,
        formatDateTimeJapanese,
        CONFIG_TABLE_TAB_10,
        toggleCommonSwitch,
        SWITCH_FIELD_TAB_10,
        calculateRowspan,

        handleCheckBoxValue(fieldName, type, index) {
            const payload = onHandleDataCheckValueForPartner(this.keyTab, this.dataObject, fieldName);
            this.$emit('handleTabCheckBoxValue', { payload, fieldName, type, index });
        }
    },

    watch: {},
    mounted() {}
};
</script>
